import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Cell } from '../../../lib/data-set/cell';

@Component({
    selector: 'table-cell-edit-mode',
    template: `
    <div [ngSwitch]="getEditorType()">
      <table-cell-custom-editor
        *ngSwitchCase="'custom'"
        [cell]="cell"
        [inputClass]="inputClass"
        (edited)="onEdited($event)"
      >
      </table-cell-custom-editor>
      <table-cell-default-editor
        *ngSwitchDefault
        [cell]="cell"
        [inputClass]="inputClass"
        (edited)="onEdited($event)"
        (blur)="onBlur($event)"
      >
      </table-cell-default-editor>
    </div>
  `,
    standalone: false
})
export class EditCellComponent {
  @Input() public cell: Cell;
  @Input() public inputClass: string = '';

  @Output() public edited = new EventEmitter<any>();
  @Output() public blur = new EventEmitter<any>();

  public onEdited(event: any): boolean {
    this.edited.next(event);
    return false;
  }

  public onBlur(event: any) {
    this.blur.emit(event);
  }

  public getEditorType(): string {
    return this.cell.getColumn().editor && this.cell.getColumn().editor.type;
  }
}